import {
  Box,
  Container,
  Heading,
  Stack,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link,
  UnorderedList,
  ListItem
} from '@chakra-ui/react';

interface FaqData {
  question: string,
  answer: any
};

const FaqItem = ({question, answer}: FaqData) => {
  return (
    <AccordionItem bg={'yellow.200'}>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left' fontSize={'2xl'}>
          {question}
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} fontSize={'lg'} textColor='gray.600' bg='yellow.100' p={10}>
      {answer}
    </AccordionPanel>
  </AccordionItem>
  );
}

export default function GridListWithHeading() {
  return (
    <Box p={4} py='20'>
      <Stack spacing={4} as={Container} maxW={'3xl'} textAlign={'center'}>
        <Heading fontSize={'5xl'} color='black'>FAQ</Heading>
        <Text color={'gray.600'} fontSize={'2xl'}>
          Get to know more about Crangon!
        </Text>
      </Stack>


      <Accordion defaultIndex={[]} allowMultiple px={'200'} py={'10'}>
        <FaqItem question='What is Crangon?'
          answer={<p>Crangon is a decentralized borrowing protocol that allows you to draw 0% interest loans against BNB used as collateral. Loans are paid out in CUSD - a USD pegged stablecoin, and need to maintain a minimum collateral ratio of only 110%. <br />
          <br />
          In addition to the collateral, the loans are secured by a Stability Pool containing CUSD and by fellow borrowers collectively acting as guarantors of last resort. Learn more about these mechanisms under Liquidations. <br />
          <br />
          Crangon as a protocol is non-custodial, immutable and governance-free. Learn more about the protocol <Link href='https://chengh826.gitbook.io/crangon-docs/' color='yellow.600'>here</Link>. <br /></p>}
        />

        <FaqItem question='How can I use Crangon?'
          answer={<p>You can directly interact with the protocol via the web interface <Link href='https://crangon.web.app/' color='yellow.600'>here</Link>.</p>}
        />

        <FaqItem question='What are the key benefits of Crangon?'
          answer={<p>Crangon offers the best borrowing conditions on the market with the main benefits being: <br />
          <br />
          <UnorderedList>
            <ListItem>0% interest rate</ListItem>
            <ListItem>A collateral ratio of just 110%</ListItem>
            <ListItem>Governance free - all operations are algorithmic and fully automated</ListItem>
            <ListItem>Directly redeemable -  CUSD can be redeemed at face value for the underlying collateral, always and at any time</ListItem>
            <ListItem>Censorship resistant - the protocol is controlled by nobody</ListItem>
        </UnorderedList></p>}
        />

        <FaqItem question='How can I earn money on Crangon?'
          answer={<p>There are basically two different ways to generate revenue using Crangon: <br />
          <br />
          1. <b>Deposit CUSD</b> to the Stability Pool and earn liquidation gains and CGN rewards <br />
          2. <b>Stake CGN</b> and earn the revenue from issuance fees (in CUSD) and redemption fees (in BNB)</p>}
        />

      </Accordion>
    </Box>
  );
}
